import { getErrorHandler } from '@office-start/error-handler';
import { KnownInstrumentationEvents, } from '@office-start/instrumentation-types';
import { getRequestIdFromResponse, httpGet } from '@office-start/xhr-service';
import { getGraphServiceEndpoint } from '../utilities/getGraphServiceEndpoint';
var oneDriveBaseUrlSearchRegex = /^https?:\/\/(.(?!\/))*.\//i;
var myDriveRootEndpoint = 'me/drive/root';
export function getMyDriveRootUrls(graphXhrOptions, isConsumer, inMockMode) {
    var url = getGraphServiceEndpoint(graphXhrOptions.graphApiRoot, myDriveRootEndpoint, false);
    var requestConfig = {
        method: "GET" /* HttpRequestMethod.Get */,
    };
    if (inMockMode) {
        // TODO: mock mode scenario
        return Promise.resolve({
            tenantRoot: '',
            userRoot: '',
        });
    }
    return httpGet(KnownInstrumentationEvents.OneDriveGraphMyDriveRootURLRequest, "OneDrive_Graph_MyDriveRootURL" /* KnownRequestInstrumentationEvents.OneDriveGraphMyDriveRootURLRequest */, url, requestConfig, graphXhrOptions.jwtAuthEnabled, graphXhrOptions.getAccessToken, graphXhrOptions.officeApiRoot, graphXhrOptions.correlationId, 'Graph', {
        populateRequestEvent: function (response, params) {
            params["RequestId" /* InstrumentationParam.RequestId */] =
                getRequestIdFromResponse(response) || '';
        },
    })
        .then(function (response) {
        var rootItem = response.data;
        var tenantOneDriveRootUrl = null;
        var userOneDriveRootUrl = rootItem ? rootItem.webUrl : null;
        if (!userOneDriveRootUrl) {
            throw new Error((response === null || response === void 0 ? void 0 : response.statusText) || 'userOneDriveRootUrl empty');
        }
        if (!isConsumer) {
            // ex. https://contoso-my.sharepoint.com/personal/jsmith_contoso_com/documents
            var oneDriveRootMatches = oneDriveBaseUrlSearchRegex.exec(userOneDriveRootUrl);
            if (oneDriveRootMatches && oneDriveRootMatches.length) {
                tenantOneDriveRootUrl = oneDriveRootMatches[0];
            }
        }
        return {
            tenantRoot: tenantOneDriveRootUrl,
            userRoot: userOneDriveRootUrl,
        };
    })
        .catch(function (error) {
        getErrorHandler().handleError(error, "m01Uz" /* ErrorId.m01Uz */);
        return null;
    });
}
//# sourceMappingURL=getMyDriveRootUrls.js.map